export default __webpack_public_path__ + "static/media/UFExp.4e12391c.md";